<template>
    <div class="graph_box mt-0">
        <div class="" v-if="loader">
            <div class="flex loader_class">
                <v-progress-circular
                    indeterminate
                    color="#1F8F58"
                    size="40"
                ></v-progress-circular>
            </div>
            <!-- <div class="loader_message flex">
                <p>Loading Data ......</p>
            </div> -->
        </div>
        <div class="mt-2 graph" v-else>
            <div class="flex">
                <small class="legend_text">{{ heading }}</small>
            </div>
            <column-chart
                :data="data"
                :legend="false"
                :messages="msg"
                :colors="['#B8D6C4']"
                height="240px"
                style="border-radius: 8px !important"
                :scale="2"
                precision="2"
                :pointWidth="30"
            ></column-chart>
        </div>
    </div>
</template>

<script>
import methods from "../../../../helpers/methods";
export default {
    name: "columnGraph",
    data() {
        return {
            searchTextData: null,
            data: [],
            heading: "",
            loader: false,
            msg: { empty: "Please Select a Date Range " },
        };
    },
    watch: {
        searchTextData: function (val) {
            console.log("qweertty", val);
            this.heading = val.display_text;
            this.formatSearchData();
        },
        data: function (val) {
            console.log("qweertty data", val);
        },
    },
    methods: {
        formatSearchData() {
            this.data = [];
            const data = {};
            if (this.searchTextData.entries.length == 0) {
                this.msg = { empty: " No data present " };
            }
            this.searchTextData.entries.map((item, i) => {
                if (i < 10) {
                    data[item.name] = item.count;
                }
            });

            console.log("qweert", data);
            this.data.push({ data });
            setTimeout(() => {
                this.loader = false;
            }, 300);
        },
    },
};
</script>
<style scoped >
.graph_box {
    background-color: #fbfbfb;
    height: 300px;
    border-radius: 8px;
    overflow-x: scroll;
}
.graph {
    padding: 1rem;
}
.legend_text {
    font-size: 12px;
    text-align: center;
    color: #918989;
}
.loader_class {
    /* transform: translate3d(50%,0%,0%); */
    height: 300px;
    /* transform: translateY(-1%) */
}
.loader_message {
    transform: translateY(-100px);
}
</style>